import webApi from './webApi'
import { ApiClient } from './ApiClient'
import { IIncidentsData } from '../types/Incidents/IIncidentTypes'
import { IEnforcementContactsData } from '../types'

const GetReports = async (
apiClient: ApiClient, storeCode: string, page: number, type?: string | null): Promise<IIncidentsData | IEnforcementContactsData> => {
  const response = await webApi.get<IIncidentsData | IEnforcementContactsData>(apiClient, {
    url: `/api/reports`,
    params: { 
      storeCode: storeCode, 
      pageNumber: page, 
      ...(type !== null && type !== undefined ? { reportType: type } : {})
     },
  })
  return response
}

const reportsApi = {
  GetReports
}

export default reportsApi
